import React from 'react';

import ErrorPage from './ErrorPage/ErrorPage';
import { logError } from '../logError';

export class ErrorBoundary extends React.Component {
  state = {
    error: false,
  };

  static getDerivedStateFromError() {
    return { error: true };
  }

  componentDidCatch(errorObj) {
    logError(errorObj);
    this.setState({ error: true });
  }

  render() {
    if (this.state.error) {
      return <ErrorPage type="error" />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/js/components/ErrorBoundary.js